import FooterSimplified from './FooterSimplified';

export default FooterSimplified;
